
import filter from 'lodash/filter';
import get from 'lodash/get';
import find from 'lodash/find';
import { trim } from 'lodash';

import individualTest from '../constants/json/checkboxes/individualTestPackages.json';
import MaterialTypes from '../constants/json/radiobuttons/materialTypes.json';
import { hasLegacyRecycleAnswers } from '../constants/recycleContentOptions.js';
import {
  toggleAddMaterailModal,
  displaySubmitButtonTrf,
  displayClearButtonTrf,
  updateMaterialField,
  clearFormValueTRF,
  InitialProductTypeStore,
  currentProductTypeStore,
  onChangeProductType,
  onChangeScreeningInkVarient,
  getProductIdEdit,
  initialCertificationArry,
  recycledContentValue,
  onChangeRetest,
  productTypeChangeStatus
} from '../actions/trfActions.js';
import { createServiceAction } from '../util/actionHelper.js';
import {
  brandInfoValidations,
  brandInfoValidationsForEdit,
  testingInfoValidations,
  labLocationValidations,
  clearTestingInfo,
  testingInfoValidationsForEdit,
  labLocationValidationsForEdit
} from '../validations/trfValidations/trfValidations.js';

const defaultState = {
  isAddMaterialModalOpen: false,
  updateMaterialField: [],
  initialCertificationArry: [],
  errorClassName: [true, true, true, true],
  sampleType: '',
  testingType: 'PR',
  toysPackage: [],
  isLoading: false,
  preLoadComponents: false,
  updateEnable: false,
  listLicenseeRemainingPages: {},
  countPerPage: {},
  totalCount: {},
  currentPage: {},
  nextPage: 1,
  InitialProductTypeStore: 1,
  currentProductTypeStore: 1,
  getProductIdEdit: 1,
  onChangeProductType: [],
  onChangeScreeningInkVarient: 0,
  recycledContentValue: 'No',
  isRetestEnable:'No',
  labLocationCountries: [],
  labLocationsLoading: false,
  //productTypeChangeStatus:false
};

let brandArray = {
  brandId: false,
  productId: false,
  isLicensee: false,
  isMaterial: '',
  isError: true,
  isRetest: false,
  originalTRF:'',
  materialType: [],
  testPackagesValidationArry:[]

};
let testInfoArray = {
  isMaterial: '',
  season: false,
  variants: false,
  testingType: 'PR',
  isMaterialTypeVariant: true,
  isMaterialType: false,
  materialNames: [],
  isVariant: true,
  materialType: '',
  pColor: '',
  sampleDescription: '',
  repellent: false,
  foodOrMouth: false,
  isTestingType: false,
  testPackages: [],
  testPackage: '',
  isTestPackageVariant: true,
  //subRecycledContent:'',
  //recycledContent:'',
  isError: true,
  subVariants: 0,
  sampleType: '',
  ageGroup: '',
  sampleColor: '',
  // Initialized arrays and fields to prevent undefined.filter errors
  testPackagesJewelryValidationArry: [],
  testPackagesElectronicValidationArry: [],
  testPackagesPackagingValidationArry: [],
  testPackagesForEdit: [],
  testPackageVariants: [],
  multiVariantMaterial: false,
  multiVariants: [],
  electCategory: '',
  skinContact: false,
  recycle: false,
  recycleSource: '',
  recycleMethod: '',
  describeRecycle: '',
  jewelryMaterialTypeValidation: ''
};
let labSelectionArray = {
  islabSelect: false,
  locationPayload: '',
  labLocation: false,
  isServiceRequest: false,
  isError: true
};
let reviewSelectionArray = {
  isError: true
};

let pcxData = {
  typeOfMaterial: '',
  isCompleted: false
};

let activeForm = 'noForm';
let brandInfoModify = false;
let testingInfoModify = false;
let labLocationModify = false;

let currentProductId = 1;
let previewProductId = 1;
let editProductId = 1;

const hasValue = value => {
  if (typeof value === 'string') {
    return trim(value) !== '';
  }
  return value !== null && typeof value !== 'undefined' && value !== '';
};

const isRecycleSectionValid = info => {
  const isRecycleYes = info.recycle === true || info.recycle === 'Yes';
  if (!isRecycleYes) {
    return true;
  }

  const sourceValue = info.recycleSource || info.listRecycle || '';
  const isLegacyRecycleFlow = info.testingInfoStatus === 'Edit'
    && !hasValue(info.recycleMethod)
    && hasLegacyRecycleAnswers(sourceValue);
  const hasRecycleSource = hasValue(sourceValue);
  const hasRecycleMethod = isLegacyRecycleFlow || hasValue(info.recycleMethod);
  const hasRecycleDescription = hasValue(info.describeRecycle);

  return hasRecycleSource && hasRecycleMethod && hasRecycleDescription;
};

const toValidProductId = (value) => {
  const normalizedValue = Number(value);
  return Number.isInteger(normalizedValue) && normalizedValue >= 200 ? normalizedValue : null;
};

const resolveEffectiveProductId = (info = {}) => {
  return (
    toValidProductId(info.productIdEdit) ||
    toValidProductId(editProductId) ||
    toValidProductId(info.currentProductType) ||
    toValidProductId(info.InitialProductType) ||
    toValidProductId(previewProductId) ||
    toValidProductId(currentProductId)
  );
};

function validate(formDetails,isRetestEnable) {
  if (formDetails.meta.form === 'brandInfo' && formDetails.payload.brandInfoStatus === 'Edit' && activeForm !== 'noForm' && !brandInfoModify) {
    activeForm = formDetails.payload.activeForm;
    brandInfoModify = true;
    brandArray = brandInfoValidationsForEdit(formDetails.meta.field, formDetails.payload, 'Edit');
    if (
      brandArray.brandId &&
      brandArray.productId &&
      brandArray.isMaterial !== '' &&
      brandArray.isMaterialNumber !== ''
    ) {
      brandArray.isError = false;
    } else {
      brandArray.isError = true;
    }
    if (brandArray.isRetest === "Yes" && !brandArray.originalTRF) {
      brandArray.isError = true;
    }   
  }
  //The validation is for Edit the form & after change the form value it will read the testingInfoStatus as Create
  if (formDetails.meta.form === 'testingInfo' && formDetails.payload.testingInfoStatus === 'Edit'
    && activeForm !== formDetails.payload.activeForm && !testingInfoModify) {
    activeForm = formDetails.payload.activeForm;
    testingInfoModify = true;
    testInfoArray = testingInfoValidationsForEdit(formDetails.meta.field, formDetails.payload, editProductId);
    //To return the error true/false for Materials & Test packages section
    materialAndtestPackagesValidation(testInfoArray,isRetestEnable)
  }
  if (formDetails.meta.form === 'labLocation' && formDetails.payload.labInfoStatus === 'Edit' && activeForm !== formDetails.payload.activeForm && !labLocationModify) {

    labSelectionArray = labLocationValidationsForEdit(formDetails.meta.field, formDetails.payload, 'Edit');

    if (labSelectionArray[`labLocation${labSelectionArray.locationPayload}`]) {
      labSelectionArray.isError = false;
    } else {
      labSelectionArray.isError = true;
    }
    activeForm = formDetails.payload.activeForm;
    labLocationModify = true;
  }
  if (!brandArray.isError && !testInfoArray.isError && !labSelectionArray.isError) {
    reviewSelectionArray.isError = false;
  } else {
    reviewSelectionArray.isError = true;
  }
  return [brandArray.isError, testInfoArray.isError, labSelectionArray.isError, reviewSelectionArray.isError];
}

function materialAndtestPackagesValidation(testInfoArray,isRetestEnable) {
  const recycleValidationStatus = isRecycleSectionValid(testInfoArray);


  let returnFieldsStatus = testInfoArray.season && trim(testInfoArray.sampleDescription) !== ''
    && testInfoArray.sampleDescription !== 'N/A' && testInfoArray.sampleType !== '' && testInfoArray.ageGroup !== ''
    && testInfoArray.sampleColor !== '' && recycleValidationStatus
  /* && ((testInfoArray.subRecycledContent === 'Yes'  && testInfoArray.recycledContent === 'Yes' ) 
  || testInfoArray.recycledContent === 'No' ) */
  //testInfoArray.testingType = testInfoArray.testingType;

  const effectiveProductId = resolveEffectiveProductId(testInfoArray);

  //Edit TRF Form to Validate the Material & Individual Tests for Electric Product Type
  if (effectiveProductId === 204) {
    toValidateElectronicProduct(testInfoArray, returnFieldsStatus,isRetestEnable)
  }
  else if (effectiveProductId === 205) {
    toValidateJewelryProduct(testInfoArray, returnFieldsStatus,isRetestEnable)
  }
  else if (effectiveProductId === 206) {
    toValidateAccessoriesProduct(testInfoArray, returnFieldsStatus)
  }
  else if (effectiveProductId === 200 || effectiveProductId === 201 || effectiveProductId === 202 || effectiveProductId === 203) {
    toValidatePrRd(testInfoArray, returnFieldsStatus,isRetestEnable)
  }
  if (effectiveProductId !== 204) {
    toValidateMaterialSubOptions(testInfoArray, returnFieldsStatus)
  }
  if (testInfoArray.isMaterial === '') {
    testInfoArray.isError = true;
  }
  if (testInfoArray.multiVariantMaterial && testInfoArray.multiVariants.filter(element => element != null).length === 0) {
    testInfoArray.isError = true;
  }
}
function materialChangeTestingInfo(testInfoArray, brandArray) {
  if (
    testInfoArray.season &&
    brandArray.isMaterial !== '' &&
    !(testInfoArray.materialNames.filter(element => element != null).length === 0) &&
    !testInfoArray.isMaterialVarient &&
    testInfoArray.testingType === 'PR'
  ) {
    return false;
  } else if (
    testInfoArray.season &&
    brandArray.isMaterial !== '' &&
    !(testInfoArray.materialNames.filter(element => element != null).length === 0) &&
    testInfoArray.allVarientPresent &&
    testInfoArray.testingType === 'PR'
  ) {
    return false;
  } else if (testInfoArray.season && testInfoArray.testingType === 'RD' && testInfoArray.repellent && brandArray.isMaterial !== '') {
    return false;
  } else if (
    // R&D: material types selected (with or without variants) — sufficient on its own
    testInfoArray.season &&
    brandArray.isMaterial !== '' &&
    !(testInfoArray.materialNames.filter(element => element != null).length === 0) &&
    testInfoArray.testingType === 'RD'
  ) {
    return false;
  } else if (
    testInfoArray.season &&
    brandArray.isMaterial !== '' &&
    testInfoArray[`tp-variants${testInfoArray.testPackage}`] &&
    testInfoArray.testingType === 'RD' &&
    !testInfoArray.repellent
  ) {
    return false;
  } else if (
    // R&D: individual tests selected — sufficient on its own
    testInfoArray.season &&
    brandArray.isMaterial !== '' &&
    !(testInfoArray.testPackagesValidationArry.filter(element => element != null).length === 0) &&
    !testInfoArray.isTestPackageVariant &&
    testInfoArray.testingType === 'RD'
  ) {
    return false;
  } else if (
    // R&D: packaging / electronic / jewelry test packages selected — sufficient on their own
    testInfoArray.season &&
    brandArray.isMaterial !== '' &&
    testInfoArray.testingType === 'RD' &&
    (
      (Array.isArray(testInfoArray.testPackagesPackagingValidationArry) && testInfoArray.testPackagesPackagingValidationArry.filter(element => element != null).length > 0) ||
      (Array.isArray(testInfoArray.testPackagesElectronicValidationArry) && testInfoArray.testPackagesElectronicValidationArry.filter(element => element != null).length > 0) ||
      (Array.isArray(testInfoArray.testPackagesJewelryValidationArry) && testInfoArray.testPackagesJewelryValidationArry.filter(element => element != null).length > 0) ||
      (Array.isArray(testInfoArray.testPackage) && testInfoArray.testPackage.filter(element => element != null).length > 0) ||
      (Array.isArray(testInfoArray.testPackagesForEdit) && testInfoArray.testPackagesForEdit.filter(element => element != null).length > 0)
    )
  ) {
    return false;
  }
  // Ensure R&D mode requires at least one material type OR individual test selected
  if (testInfoArray.testingType === 'RD') {
    const hasMaterial = Array.isArray(testInfoArray.materialNames) && testInfoArray.materialNames.some(element => element != null);
    const hasTest = [
      testInfoArray.testPackagesValidationArry,
      testInfoArray.testPackagesPackagingValidationArry,
      testInfoArray.testPackagesElectronicValidationArry,
      testInfoArray.testPackagesJewelryValidationArry,
      testInfoArray.testPackagesForEdit,
      testInfoArray.testPackage
    ].some(arr => {
      if (Array.isArray(arr)) return arr.some(element => element != null);
      return arr && arr !== '';
    });
    if (!hasMaterial && !hasTest) {
      return true; // Fail validation - R&D requires material or test selection
    }
  }
  if (testInfoArray.multiVariantMaterial && testInfoArray.multiVariants.filter(element => element != null).length === 0) {
    return true;
  }
  return true
}

function brandInfoValidationsArry(formDetails, testInfoArray) {
  if (formDetails.meta.form === 'brandInfo') {
    brandArray = brandInfoValidations(formDetails.meta.field, formDetails.payload, 'Create');
    let testinInfoCheckForMaterialChange = materialChangeTestingInfo(testInfoArray, brandArray)
    if (
      brandArray.brandId &&
      brandArray.productId &&
      brandArray.isLicensee &&
      brandArray.isMaterialNumber !== ''
    ) {
      brandArray.isError = false;
    } else {
      brandArray.isError = true;
    }
    if (brandArray.isLicensee === "Yes" && !brandArray.licensee) {
      brandArray.isError = true;
    }
    if (brandArray.isRetest === "Yes" && !brandArray.originalTRF ) {
      brandArray.isError = true;
    }    
    if (brandArray.isMaterial === '') {
      brandArray.isError = true;
      testInfoArray.isError = true;
    }
    if(brandArray.materialType && brandArray.materialType[0] === null){
      testInfoArray.isError = true;
    }
    if(brandArray.testPackagesValidationArry ===  null){
      testInfoArray.testPackagesValidationArry = [null]
      testInfoArray.testPackagesForEdit=[null]
      delete testInfoArray[`tp-variants${testInfoArray.testPackage}`]
      testInfoArray.testPackages = []
      testInfoArray.testPackageVariants = []
      testInfoArray.variants = false
      testInfoArray.selectedPackages = true
      testInfoArray.testPackage = ''
      testInfoArray.isTestPackageVariant = false;
      testInfoArray.testPackagesElectronicValidationArry = []
      testInfoArray.testPackagesJewelryValidationArry = []
      testInfoArray.testPackagesPackagingValidationArry = []
      testInfoArray.isError = true;
      testInfoArray.materialNames = [null]
    }
    if (!testinInfoCheckForMaterialChange && brandArray.testPackagesValidationArry !==  null) {
      testInfoArray.isError = false;
    } else {
      testInfoArray.isError = true;
    }
  }
}

//To validate the Material Variants validation
function toValidateMaterialSubOptions(testInfoArray, returnFieldsStatus) {
  const selectedMaterials = testInfoArray.materialNames.filter(element => element != null);

  const isRD = testInfoArray.testingType === 'RD';

  // Determine whether at least one individual test is currently selected.
  // In R&D mode "either material type OR individual tests" is sufficient, so when
  // individual tests are selected we must not override a passing result with a
  // material-variant error (and vice-versa).
  const hasIndividualTests = (
    (Array.isArray(testInfoArray.testPackagesValidationArry) && testInfoArray.testPackagesValidationArry.filter(element => element != null).length > 0) ||
    (Array.isArray(testInfoArray.testPackagesPackagingValidationArry) && testInfoArray.testPackagesPackagingValidationArry.filter(element => element != null).length > 0) ||
    (Array.isArray(testInfoArray.testPackagesElectronicValidationArry) && testInfoArray.testPackagesElectronicValidationArry.filter(element => element != null).length > 0) ||
    (Array.isArray(testInfoArray.testPackagesJewelryValidationArry) && testInfoArray.testPackagesJewelryValidationArry.filter(element => element != null).length > 0) ||
    (Array.isArray(testInfoArray.testPackage) && testInfoArray.testPackage.filter(element => element != null).length > 0) ||
    (Array.isArray(testInfoArray.testPackagesForEdit) && testInfoArray.testPackagesForEdit.filter(element => element != null).length > 0)
  );

  if (selectedMaterials.length > 0) {
    // Validate material 405 (Inks and Paints)
    if (selectedMaterials.includes(405)) {
      if (testInfoArray[`variants405`] === 4040){
        testInfoArray.isError = true;
      if (testInfoArray.pColor === '' || !returnFieldsStatus) {
        testInfoArray.isError = true;
            } else {
        testInfoArray.isError = false;
            }
       }
      if (testInfoArray[`variants405`] === 4052) {
        testInfoArray.isError = true;
        if (testInfoArray[`variants405`] === 4052 && (testInfoArray.subVariants === 4050 || testInfoArray.subVariants === 4051)
          && testInfoArray.pColor !== '' && returnFieldsStatus) {
          testInfoArray.isError = false;
        } else {
          testInfoArray.isError = true;
        }
      }
    }
    
    // Validate material 408
    if (selectedMaterials.includes(408)) {
      if((testInfoArray[`variants408`] === 4080 ||
      testInfoArray[`variants408`] === 4081) && testInfoArray.pColor !== '' && returnFieldsStatus){
        testInfoArray.isError = false;
      }else{
        testInfoArray.isError = true;
      }
    }
    
    if (selectedMaterials.includes(409)) {
      //toValidateMetalItems(testInfoArray, returnFieldsStatus)
    }
    
    // Validate that all selected materials with required variants have their variants selected.
    // In R&D mode: when individual tests are already selected, skip this check — selecting
    // individual tests is sufficient validation and should not be overridden by a missing
    // material variant (user may have unchecked a material or is doing preliminary testing).
    if (!isRD || !hasIndividualTests) {
      selectedMaterials.forEach(materialId => {
        const materialConfig = find(MaterialTypes, ['id', materialId]);
        if (materialConfig && materialConfig.variant) {
          const hasVariantValue = Object.prototype.hasOwnProperty.call(testInfoArray, `variants${materialId}`)
            && testInfoArray[`variants${materialId}`] !== null
            && testInfoArray[`variants${materialId}`] !== undefined;
          
          // If variant is not present and not optional, mark as error
          if (!hasVariantValue && !materialConfig.variantNotMandatory) {
            testInfoArray.isError = true;
            if (materialConfig.variant && !returnFieldsStatus && materialId !== 405) {
              testInfoArray.isError = true;
            }
          }
        }
      });
    }
  } else {
    // No materials selected — check for orphaned variant values left behind when a
    // material type was unchecked.
    // In R&D mode: skip this check entirely. The user may have unchecked all material
    // types and is now relying on individual tests (which is valid for R&D). The stale
    // variant field does not reflect a user intent error in that case.
    if (!isRD) {
      let hasOrphanedVariants = false;
      MaterialTypes.forEach(material => {
        if (material.variant) {
          const variantValue = testInfoArray[`variants${material.id}`];
          if (variantValue !== null && variantValue !== undefined) {
            hasOrphanedVariants = true;
          }
        }
      });
      
      if (hasOrphanedVariants) {
        testInfoArray.isError = true;
      }
    }
  }
}
//This Validation is only for Product Type 204 (Electronics)
function tovalidateInksAndPaintsForElectronic(testInfoArray, returnFieldsStatus) {
  if (testInfoArray.materialNames.filter(element => element != null).length > 0) {
    if (testInfoArray.materialNames.filter(element => element != null).includes(405)) {
      if ((testInfoArray[`variants405`] === 4040) && testInfoArray.pColor === '' && testInfoArray.electCategory === "") {
        testInfoArray.isError = true;
      }
      if (testInfoArray[`variants405`] === 4052) {
        testInfoArray.isError = true;
        if (testInfoArray[`variants405`] === 4052 && (testInfoArray.subVariants === 4050 || testInfoArray.subVariants === 4051)
          && testInfoArray.electCategory !== "" && testInfoArray.pColor !== '') {
          testInfoArray.isError = false;
        } else {
          testInfoArray.isError = true;
        }
      }
      if(testInfoArray[`variants405`] === null){
        testInfoArray.isError = true;
      }
    }
    if (testInfoArray.materialNames.filter(element => element !== null).includes(408)) {
      if((testInfoArray[`variants408`] === 4080 ||
      testInfoArray[`variants408`] === 4081) && testInfoArray.pColor !== '' && returnFieldsStatus){
        testInfoArray.isError = false;
      }else{
        testInfoArray.isError = true;
      }
    }
    if (testInfoArray.materialNames.filter(element => element !== null).includes(409)) {
      //toValidateMetalItems(testInfoArray, returnFieldsStatus)
    }
    if (!(testInfoArray.materialNames.filter(element => element != null).length === 0)) {
      testInfoArray.materialNames.filter(element => element != null).map(materialId => {
        if (!(Object.prototype.hasOwnProperty.call(testInfoArray, `variants${materialId}`))
          && find(MaterialTypes, ['id', materialId]).variant ) {
          testInfoArray.isError = true
          if (find(MaterialTypes, ['id', materialId]).variant && !returnFieldsStatus && materialId !== 405) {
            testInfoArray.isError = true
          }
        }
        return null
      })
    }
 
  }
}


function toValidateJewelryProduct(testInfoArray, returnFieldsStatus,isRetestEnable) {
  if (testInfoArray.testingType === 'RD'|| (testInfoArray.testingType === 'PR' && isRetestEnable === 'Yes')) {
    if ((testInfoArray.jewelryMaterialTypeValidation === " " || testInfoArray.jewelryMaterialTypeValidation === "")) {
      if (
        returnFieldsStatus
        && testInfoArray.testPackagesJewelryValidationArry.filter(element => element !== null).length > 0
        && testInfoArray.testingType === 'RD') {
        testInfoArray.isError = false;
      } else {
        testInfoArray.isError = true;
      }
    } else if (testInfoArray.jewelryMaterialTypeValidation !== "" || testInfoArray.jewelryMaterialTypeValidation === " ") {
      tovalidateJewelryMaterialValidation(testInfoArray, returnFieldsStatus)
    }

  }
  else if (testInfoArray.testingType === 'PR') {
    if (testInfoArray.jewelryMaterialTypeValidation !== '' && testInfoArray.testingType === 'PR') {
      if (testInfoArray.jewelryMaterialTypeValidation === 4148) {
        if (testInfoArray[`variants4148`] && (testInfoArray[`variants4148`] === 4146 || testInfoArray[`variants4148`] === 4142) && returnFieldsStatus) {
          testInfoArray.isError = false;
        } else {
          testInfoArray.isError = true;
        }
      }
      else if (testInfoArray.jewelryMaterialTypeValidation === 4147) {
        if (testInfoArray[`variants4147`] && (testInfoArray[`variants4147`] === 4141 || testInfoArray[`variants4147`] === 4145) && returnFieldsStatus) {
          testInfoArray.isError = false;
        } else {
          testInfoArray.isError = true;
        }
      }
      else if (testInfoArray.jewelryMaterialTypeValidation === 4148 && testInfoArray.testingInfoStatus === "Edit" && returnFieldsStatus) {
        testInfoArray.isError = false;
      }
      else if ((testInfoArray.jewelryMaterialTypeValidation === 4144 || testInfoArray.jewelryMaterialTypeValidation === 4143)
        && returnFieldsStatus) {
        testInfoArray.isError = false;
      }
      else if ((testInfoArray.jewelryMaterialTypeValidation === 4146 || testInfoArray.jewelryMaterialTypeValidation === 4142
        || testInfoArray.jewelryMaterialTypeValidation === 4141 || testInfoArray.jewelryMaterialTypeValidation === 4145) && returnFieldsStatus) {
        testInfoArray.isError = false;
      }
      else {
        testInfoArray.isError = true;
      }
    }
  }
  else if ((testInfoArray.jewelryMaterialTypeValidation === '' || testInfoArray.jewelryMaterialTypeValidation === ' ')
    && testInfoArray.testingType === 'PR' && !returnFieldsStatus) {
    testInfoArray.isError = true;
  }
}


function toValidateElectronicProduct(testInfoArray, returnFieldsStatus, isRetestEnable) {
  if (testInfoArray.testingType === 'RD' || (testInfoArray.testingType === 'PR' && defaultState.isRetestEnable === 'Yes')) {
    const materialNumbersArry = testInfoArray.materialNames.filter(element => (element !== null && element !== 4150 && element !== 4152)).length
    const testPakageElectronics = testInfoArray.testPackagesElectronicValidationArry.filter(element => (element !== null)).length
    if (testInfoArray.skinContact === true) {
      let electCategoryStatus =testInfoArray.electCategory !== "" ? true : false
      returnFieldsStatus = returnFieldsStatus && electCategoryStatus
      if (returnFieldsStatus 
        && materialNumbersArry > 0) {
        testInfoArray.isError = false;
        tovalidateInksAndPaintsForElectronic(testInfoArray, returnFieldsStatus)
      } else {
        testInfoArray.isError = true;
      }
    }
    else if (testInfoArray.skinContact === false) {
      if (returnFieldsStatus &&
        (testInfoArray.electCategory !== "" ||
          (testPakageElectronics > 0))) {
        testInfoArray.isError = false;
        } else {
        testInfoArray.isError = true;
      }
      tovalidateInksAndPaintsForElectronic(testInfoArray, returnFieldsStatus)
    }
  } else if (testInfoArray.testingType === 'PR' && isRetestEnable !== 'Yes') {
    //brandArray.isMaterial is comming from Create Validation
    //testInfoArray.isMaterial is comming from Edit Validation (testingInfoValidationsForEdit function)
    let electCategoryStatus =testInfoArray.electCategory !== "" ? true : false
    returnFieldsStatus = returnFieldsStatus && electCategoryStatus
    if (testInfoArray.skinContact === true) {
      if (
        returnFieldsStatus &&
        (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
        !(testInfoArray.materialNames.filter(element => element != null && element !== 4150 && element !== 4152).length === 0) //4150 & 4152 already added in materialNames array
      ) {
        testInfoArray.isError = false
        tovalidateInksAndPaintsForElectronic(testInfoArray, returnFieldsStatus)
      } else {
        testInfoArray.isError = true
      }
    } else if (testInfoArray.skinContact === false) {
      if(returnFieldsStatus){
      testInfoArray.isError = false;
      if (testInfoArray.materialNames.filter(element => element != null).length > 0) {
        if (testInfoArray.materialNames.filter(element => element != null).includes(405)) {
          if ((testInfoArray[`variants405`] === 4040) && testInfoArray.pColor === '') {
            testInfoArray.isError = true;
          }
          if (testInfoArray[`variants405`] === 4052) {
            testInfoArray.isError = true;
            if (testInfoArray[`variants405`] === 4052 && (testInfoArray.subVariants === 4050 || testInfoArray.subVariants === 4051)
              && testInfoArray.pColor !== '') {
              testInfoArray.isError = false;
            } else {
              testInfoArray.isError = true;
            }
          }
        }
        else if (testInfoArray.materialNames.filter(element => element !== null).includes(408)) {
          if((testInfoArray[`variants408`] === 4080 ||
          testInfoArray[`variants408`] === 4081) && testInfoArray.pColor !== '' && returnFieldsStatus){
            testInfoArray.isError = false;
          }else{
            testInfoArray.isError = true;
          }
        }
        else if(testInfoArray.materialNames.filter(element => element !== null).includes(409)){
         // toValidateMetalItems(testInfoArray, returnFieldsStatus)
        }
        if (!(testInfoArray.materialNames.filter(element => element != null).length === 0)) {
          testInfoArray.materialNames.filter(element => element != null).map(materialId => {
            if (!(Object.prototype.hasOwnProperty.call(testInfoArray, `variants${materialId}`))
              && find(MaterialTypes, ['id', materialId]).variant) {
              if (find(MaterialTypes, ['id', materialId]).variant) {
                testInfoArray.isError = true
              }
            }
            return null
          })
        }
      }
    }else{
      testInfoArray.isError = true;
      }
    }
  }
  
}
function tovalidateJewelryMaterialValidation(testInfoArray, returnFieldsStatus) {
  if (testInfoArray.jewelryMaterialTypeValidation === 4148) {
    if ((testInfoArray[`variants4148`] === 4146 || testInfoArray[`variants4148`] === 4142) && returnFieldsStatus) {
      testInfoArray.isError = false;
    }
  }
  else if (testInfoArray.jewelryMaterialTypeValidation === 4147) {
    if (testInfoArray[`variants4147`] && (testInfoArray[`variants4147`] === 4141 || testInfoArray[`variants4147`] === 4145) && returnFieldsStatus) {
      testInfoArray.isError = false;
    }
  }
  else if ((testInfoArray.jewelryMaterialTypeValidation === 4144 || testInfoArray.jewelryMaterialTypeValidation === 4143) && returnFieldsStatus) {
    testInfoArray.isError = false;
  }
  else if ((testInfoArray.jewelryMaterialTypeValidation === 4146 || testInfoArray.jewelryMaterialTypeValidation === 4142
    || testInfoArray.jewelryMaterialTypeValidation === 4141 || testInfoArray.jewelryMaterialTypeValidation === 4145) && returnFieldsStatus) {
    testInfoArray.isError = false;
  } else {
    testInfoArray.isError = true;
  }
}

function accessoriesProductTypePr(testInfoArray, returnFieldsStatus) {
  if (
    returnFieldsStatus &&
    (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
    !(testInfoArray.materialNames.filter(element => element != null && element !== 4150 && element !== 4152
      && element !== 4143 && element !== 4144 && element !== 4147 && element !== 4148).length === 0) &&
    !testInfoArray.isMaterialVarient &&
    testInfoArray.testingType === 'PR'
  ) {
    toValidateMaterialSubOptions(testInfoArray, returnFieldsStatus)
    testInfoArray.isError = false;
  }
  else if (
    returnFieldsStatus &&
    (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
    !(testInfoArray.materialNames.filter(element => element != null && element !== 4150 && element !== 4152
      && element !== 4143 && element !== 4144 && element !== 4147 && element !== 4148).length === 0) &&
    testInfoArray.allVarientPresent &&
    testInfoArray.testingType === 'PR'
  ) {
    toValidateMaterialSubOptions(testInfoArray, returnFieldsStatus)
    testInfoArray.isError = false;
  }
  else if (testInfoArray.jewelryMaterialTypeValidation !== '' && testInfoArray.jewelryMaterialTypeValidation !== ' ' &&
    (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '')) {
    tovalidateJewelryMaterialValidation(testInfoArray, returnFieldsStatus)
  }
  else if (
    returnFieldsStatus &&
    (testInfoArray.electCategory !== "") &&
    (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '')
  ) {
    testInfoArray.isError = false
  }
  else {
    testInfoArray.isError = true;
  }
  
 
}
function accessoriesProductTypeRd(testInfoArray, returnFieldsStatus) {
  if (
    returnFieldsStatus &&
    (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
    !(testInfoArray.materialNames.filter(element => element != null && element !== 4150 && element !== 4152
      && element !== 4143 && element !== 4144 && element !== 4147 && element !== 4148).length === 0) &&
    !testInfoArray.isMaterialVarient &&
    testInfoArray.testingType === 'RD'
  ) {
    toValidateMaterialSubOptions(testInfoArray, returnFieldsStatus)
    testInfoArray.isError = false;
  }
  else if (
    returnFieldsStatus &&
    (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
    !(testInfoArray.materialNames.filter(element => element != null && element !== 4150 && element !== 4152
      && element !== 4143 && element !== 4144 && element !== 4147 && element !== 4148).length === 0) &&
    testInfoArray.allVarientPresent &&
    testInfoArray.testingType === 'RD'
  ) {
    toValidateMaterialSubOptions(testInfoArray, returnFieldsStatus)
    testInfoArray.isError = false;
  }
  else if (testInfoArray.jewelryMaterialTypeValidation !== '' && testInfoArray.jewelryMaterialTypeValidation !== ' ' &&
    (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '')) {
    tovalidateJewelryMaterialValidation(testInfoArray, returnFieldsStatus)
  }
  else if (
    returnFieldsStatus &&
    (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
    !(testInfoArray.testPackagesElectronicValidationArry.filter(element => element != null).length === 0) &&
    !testInfoArray.isTestPackageVariant &&
    testInfoArray.testingType === 'RD'
  ) {
    testInfoArray.isError = false;
  }
  else if (
    returnFieldsStatus &&
    (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
    !(testInfoArray.testPackagesPackagingValidationArry.filter(element => element != null).length === 0) &&
    !testInfoArray.isTestPackageVariant &&
    testInfoArray.testingType === 'RD'
  ) {
    testInfoArray.isError = false;
  }
  else if (
    returnFieldsStatus &&
    (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
    !(testInfoArray.testPackagesJewelryValidationArry.filter(element => element != null).length === 0) &&
    //!testInfoArray.isTestPackageVariant &&
    testInfoArray.testingType === 'RD'
  ) {
    testInfoArray.isError = false;
  }
  else if (
    returnFieldsStatus &&
    (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
    !(testInfoArray.testPackagesForEdit.filter(element => element != null).length === 0) &&
    !testInfoArray.isTestPackageVariant &&
    testInfoArray.testingType === 'RD'
  ) {
    testInfoArray.isError = false;
  }
  else if (
    returnFieldsStatus &&
    (testInfoArray.electCategory !== "") &&
    (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '')
  ) {
    testInfoArray.isError = false
  }
  else if (
    returnFieldsStatus && (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
    !(testInfoArray.testPackagesValidationArry.filter(element => element != null).length === 0) &&
    !testInfoArray.isTestPackageVariant &&
    testInfoArray.testingType === 'RD'
  ) {
    testInfoArray.isError = false;
  }
  else if (
    returnFieldsStatus && (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
    (Array.isArray(testInfoArray.testPackages) && testInfoArray.testPackages.filter(element => element != null).length > 0) &&
    !testInfoArray.isTestPackageVariant &&
    testInfoArray.testingType === 'RD'
  ) {
    testInfoArray.isError = false;
  }
   else if (
    returnFieldsStatus && (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
    (Array.isArray(testInfoArray.testPackage) && testInfoArray.testPackage.filter(element => element != null).length > 0) &&
    //!testInfoArray.isTestPackageVariant &&
    testInfoArray.testingType === 'RD'
  ) {
    testInfoArray.isError = false;
  }
  else {
    testInfoArray.isError = true;
  }

}

function toValidateAccessoriesProduct(testInfoArray, returnFieldsStatus, editProductId) {
  if (testInfoArray.testingType === 'PR') {
    accessoriesProductTypePr(testInfoArray, returnFieldsStatus)
  } else if (testInfoArray.testingType === 'RD') {
    accessoriesProductTypeRd(testInfoArray, returnFieldsStatus)
  }
  }
function validateRdOrRetestPr(testInfoArray, returnFieldsStatus, isRetestEnable) {
  if (
    returnFieldsStatus && (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
    !(testInfoArray.materialNames.filter(element => element != null).length === 0) &&
    !testInfoArray.isMaterialVarient &&
    (testInfoArray.testingType === 'RD' ||(isRetestEnable === 'Yes' && testInfoArray.testingType === 'PR' ))
  ) {
    testInfoArray.isError = false;
  }
  else if (
    returnFieldsStatus &&
    (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
    !(testInfoArray.materialNames.filter(element => element != null).length === 0) &&
    testInfoArray.allVarientPresent &&
    (testInfoArray.testingType === 'RD' ||(isRetestEnable === 'Yes' && testInfoArray.testingType === 'PR' ))
  ) {
    testInfoArray.isError = false;
  } else if (
    returnFieldsStatus && (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
    !(testInfoArray.testPackagesValidationArry.filter(element => element != null).length === 0) &&
    !(testInfoArray.testPackagesForEdit.filter(element => element != null).length === 0) &&
    !testInfoArray.isTestPackageVariant &&
    testInfoArray.testingType === 'RD'
  ) {
    testInfoArray.isError = false;
  }
  else if (
    returnFieldsStatus &&
    (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
    !testInfoArray.isTestPackageVariant &&
    (testInfoArray.testingType === 'RD' ||(isRetestEnable === 'Yes' && testInfoArray.testingType === 'PR' ))
  ) {
    testInfoArray.isError = false;
  }
    else if (
      returnFieldsStatus && (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
      (Array.isArray(testInfoArray.testPackage) && testInfoArray.testPackage.filter(element => element != null).length > 0) &&
      !testInfoArray.isTestPackageVariant &&
      (testInfoArray.testingType === 'RD' ||(isRetestEnable === 'Yes' && testInfoArray.testingType === 'PR' ))
    ) {
      testInfoArray.isError = false;
    } 
  else if (
    returnFieldsStatus &&
    (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
    !(testInfoArray.testPackagesForEdit.filter(element => element != null).length === 0) &&
    !testInfoArray.isTestPackageVariant &&
    (testInfoArray.testingType === 'RD' ||(isRetestEnable === 'Yes' && testInfoArray.testingType === 'PR' ))
  ) {
    testInfoArray.isError = false;
  }
  else if (
    returnFieldsStatus && (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
    testInfoArray[`tp-variants${testInfoArray.testPackagesValidationArry}`] && (testInfoArray.testingType === 'RD' ||(isRetestEnable === 'Yes' && testInfoArray.testingType === 'PR' )) &&
    !testInfoArray.repellent
  ) {
    testInfoArray.isError = false;
  }
  else {
    testInfoArray.isError = true;
  }
  // Ensure R&D mode requires at least one material type OR individual test selected
  if (testInfoArray.testingType === 'RD' || (isRetestEnable === 'Yes' && testInfoArray.testingType === 'PR')) {
    const hasMaterial = Array.isArray(testInfoArray.materialNames) && testInfoArray.materialNames.some(element => element != null);
    const hasTest = [
      testInfoArray.testPackagesValidationArry,
      testInfoArray.testPackagesPackagingValidationArry,
      testInfoArray.testPackagesElectronicValidationArry,
      testInfoArray.testPackagesJewelryValidationArry,
      testInfoArray.testPackagesForEdit,
      testInfoArray.testPackage
    ].some(array => Array.isArray(array) && array.some(element => element != null));
    if (!hasMaterial && !hasTest) {
      testInfoArray.isError = true;
    }
  }
  if (resolveEffectiveProductId(testInfoArray) === 203) {
    toValidatePackagingProduct(testInfoArray, returnFieldsStatus, isRetestEnable)
  }
}

function toValidatePackagingProduct(testInfoArray, returnFieldsStatus, isRetestEnable) {
if (
      returnFieldsStatus && (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
      !(testInfoArray.testPackagesPackagingValidationArry.filter(element => element != null).length === 0) &&
      !testInfoArray.isTestPackageVariant &&
      (testInfoArray.testingType === 'RD' ||(isRetestEnable === 'Yes' && testInfoArray.testingType === 'PR' ))
    ) {
      testInfoArray.isError = false;
    }
    else if (
      returnFieldsStatus && (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
      !(testInfoArray.testPackages.filter(element => element != null).length === 0) &&
      (testInfoArray.testingType === 'RD' ||(isRetestEnable === 'Yes' && testInfoArray.testingType === 'PR' ))
    ) {
      testInfoArray.isError = false;
    }
   else if (returnFieldsStatus && (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') 
    && !(
      testInfoArray.testPackages.filter(element => element != null).length === 0 &&
      (testInfoArray.testPackage === null || testInfoArray.testPackage === '' || testInfoArray.testPackage === undefined)
    ) &&
         (testInfoArray.testingType === 'RD' ||(isRetestEnable === 'Yes' && testInfoArray.testingType === 'PR' ))) {
         testInfoArray.isError = false;
    }
}
function toValidatePrRd(testInfoArray, returnFieldsStatus,isRetestEnable) {
if (testInfoArray.testingType === 'PR' && isRetestEnable!== 'Yes') {
    if (
      returnFieldsStatus &&
      (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
      !(testInfoArray.materialNames.filter(element => element != null).length === 0) &&
      !testInfoArray.isMaterialVarient &&
      //!testInfoArray.isTestPackageVariant &&
      testInfoArray.testingType === 'PR'
    ) {
      testInfoArray.isError = false;
    }
    else if (
      returnFieldsStatus &&
      (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '') &&
      !(testInfoArray.materialNames.filter(element => element != null).length === 0) &&
      //!testInfoArray.isTestPackageVariant &&
      //testInfoArray.allVarientPresent &&
      testInfoArray.testingType === 'PR'
    ) {
      testInfoArray.isError = false;
    }
    else {
      testInfoArray.isError = true;
    }
  }
  else if (testInfoArray.testingType === 'RD' ||(isRetestEnable === 'Yes' && testInfoArray.testingType === 'PR' )) {
    validateRdOrRetestPr(testInfoArray, returnFieldsStatus, isRetestEnable);
  }
}
function isValidated(formDetails,isRetestEnable, productTypeChangeStatus) {
  brandInfoValidationsArry(formDetails, testInfoArray)
  if (formDetails.meta.form === 'testingInfo') {
    testInfoArray = testingInfoValidations(formDetails.meta.field, formDetails.payload, 'Create', currentProductId, previewProductId, editProductId, productTypeChangeStatus);
    const effectiveProductId = resolveEffectiveProductId(testInfoArray);
    testInfoArray.getProductTypeChangeStatus = productTypeChangeStatus;
    const recycleValidationStatus = isRecycleSectionValid(testInfoArray);
    let returnFieldsStatus = testInfoArray.season && trim(testInfoArray.sampleDescription) !== ''
      && testInfoArray.sampleDescription !== 'N/A' && testInfoArray.sampleType !== '' && testInfoArray.ageGroup !== '' && testInfoArray.sampleColor !== ''
      && (brandArray.isMaterial !== '' || testInfoArray.isMaterial !== '')
      && recycleValidationStatus

    //testInfoArray.testingType = testInfoArray.testingType;
    //Create TRF Form to Validate the Material & Individual Tests for Electric Product Type
    if (effectiveProductId === 204) {
      toValidateElectronicProduct(testInfoArray, returnFieldsStatus,isRetestEnable)
    }
    else if (effectiveProductId === 205) {
      toValidateJewelryProduct(testInfoArray, returnFieldsStatus,isRetestEnable)
    }
    else if (effectiveProductId === 206) {
      toValidateAccessoriesProduct(testInfoArray, returnFieldsStatus)
    }
    else if (effectiveProductId === 200 || effectiveProductId === 201 || effectiveProductId === 202 || effectiveProductId === 203) {
      toValidatePrRd(testInfoArray, returnFieldsStatus,isRetestEnable)
    }
    if (effectiveProductId !== 204) {
      toValidateMaterialSubOptions(testInfoArray, returnFieldsStatus)
    }

    //To check the Test Packages Sub options
    const AcidicVarients = filter(individualTest[0].common, { id: 501 })[0]
      .variants.map(variant => variant.id)
      .some(selectedPackage =>
        testInfoArray.testPackageVariants.filter(element => element != null).includes(selectedPackage)
      );
    const metalsChromiumVarients = filter(individualTest[0].common, { id: 601 })[0]
      .variants.map(variant => variant.id)
      .some(selectedPackage =>
        testInfoArray.testPackageVariants.filter(element => element != null).includes(selectedPackage)
      );
    const metalsNickelVarients = filter(individualTest[0].common, { id: 521 })[0]
      .variants.map(variant => variant.id)
      .some(selectedPackage =>
        testInfoArray.testPackageVariants.filter(element => element != null).includes(selectedPackage)
      );
    const metalsExtractableVarients = filter(individualTest[0].common, { id: 520 })[0]
      .variants.map(variant => variant.id)
      .some(selectedPackage =>
        testInfoArray.testPackageVariants.filter(element => element != null).includes(selectedPackage)
      );
    const JewelleryVarients = filter(individualTest[0].jewelry, { id: 590 })[0]
      .variants.map(variant => variant.id)
      .some(selectedPackage =>
        testInfoArray.testPackageVariants.filter(element => element != null).includes(selectedPackage)
      );
    if (!AcidicVarients && testInfoArray.testPackagesValidationArry.length > 0 && testInfoArray.testPackagesValidationArry.filter(element => element != null).includes(501)) {
      testInfoArray.isError = true;
    }
    if (!metalsChromiumVarients && testInfoArray.testPackagesValidationArry.length > 0 && testInfoArray.testPackagesValidationArry.filter(element => element != null).includes(601)) {
      testInfoArray.isError = true;
    }
    if (!metalsNickelVarients && testInfoArray.testPackagesValidationArry.length > 0 && testInfoArray.testPackagesValidationArry.filter(element => element != null).includes(521)) {
      testInfoArray.isError = true;
    }
    if (!metalsExtractableVarients && testInfoArray.testPackagesValidationArry.length > 0 && testInfoArray.testPackagesValidationArry.filter(element => element != null).includes(520)) {
      testInfoArray.isError = true;
    }
    if (!JewelleryVarients && testInfoArray.testPackagesJewelryValidationArry.filter(element => element != null).includes(590)) {
      testInfoArray.isError = true;
    }

    if (testInfoArray.testingInfoStatus === 'Edit' && testInfoArray.testingType === 'RD') {
      const hasMaterial = [testInfoArray.materialType, testInfoArray.materialNames]
        .some(array => Array.isArray(array) && array.some(element => element != null));
      const hasTest = [
        testInfoArray.testPackagesValidationArry,
        testInfoArray.testPackagesPackagingValidationArry,
        testInfoArray.testPackagesElectronicValidationArry,
        testInfoArray.testPackagesJewelryValidationArry
      ].some(array => Array.isArray(array) && array.some(element => element != null));
      if (!hasMaterial && !hasTest) testInfoArray.isError = true;
    }
    // Also check for Create mode - R&D requires at least one material type OR individual test
    if (testInfoArray.testingInfoStatus !== 'Edit' && testInfoArray.testingType === 'RD') {
      const hasMaterial = Array.isArray(testInfoArray.materialNames) && testInfoArray.materialNames.some(element => element != null);
      const hasTest = [
        testInfoArray.testPackagesValidationArry,
        testInfoArray.testPackagesPackagingValidationArry,
        testInfoArray.testPackagesElectronicValidationArry,
        testInfoArray.testPackagesJewelryValidationArry,
        testInfoArray.testPackagesForEdit,
        testInfoArray.testPackage
      ].some(array => Array.isArray(array) && array.some(element => element != null));
      if (!hasMaterial && !hasTest) testInfoArray.isError = true;
    }
  }
  if (formDetails.meta.form === 'labLocation') {
    labSelectionArray = labLocationValidations(formDetails.meta.field, formDetails.payload, 'Create');
    if (labSelectionArray[`labLocation${labSelectionArray.locationPayload}`]) {
      labSelectionArray.isError = false;
    } else {
      labSelectionArray.isError = true;
    }
  }
  if (!brandArray.isError && !testInfoArray.isError && !labSelectionArray.isError) {
    reviewSelectionArray.isError = false;
    defaultState.updateEnable = true;
  } else {
    reviewSelectionArray.isError = true;
  }
  return [brandArray.isError, testInfoArray.isError, labSelectionArray.isError, reviewSelectionArray.isError];
}

function getInitialProductId(id) {
  currentProductId = parseInt(id)
}
function getCurrentProductId(id) {
  previewProductId = parseInt(id)
}
function editFormProductId(id) {
  editProductId = id
}

function clearValues(action) {
  if (get(action, 'meta.form') !== 'addMaterial') {
    brandArray = {
      brandId: false,
      productId: false,
      isMaterial: '',
      labName: '',
      isError: true,
      isRetest:false,
      originalTRF: null
    };
    testInfoArray = {
      isMaterial: '',
      season: false,
      variants: false,
      testingType: 'PR',
      isMaterialTypeVariant: true,
      isMaterialType: false,
      materialNames: [],
      isVariant: true,
      materialType: '',
      pColor: '',
      sampleDescription: '',
      repellent: false,
      foodOrMouth: false,
      isTestingType: false,
      testPackages: [],
      testPackage: '',
      isTestPackageVariant: true,
      //subRecycledContent:'',
      //recycledContent:'',
      isError: true,
      subVariants: 0,
      sampleType: '',
      ageGroup: '',
      sampleColor: '',
      // Keep arrays and fields initialized after clear to avoid runtime errors
      testPackagesJewelryValidationArry: [],
      testPackagesElectronicValidationArry: [],
      testPackagesPackagingValidationArry: [],
      testPackagesForEdit: [],
      testPackageVariants: [],
      multiVariantMaterial: false,
      multiVariants: [],
      electCategory: '',
      skinContact: false,
      recycle: false,
      recycleSource: '',
      recycleMethod: '',
      describeRecycle: '',
      jewelryMaterialTypeValidation: ''
    };
    labSelectionArray = {
      islabSelect: false,
      locationPayload: '',
      labLocation: false,
      isServiceRequest: false,
      isError: true
    };
    reviewSelectionArray = {
      isError: true
    };
    brandInfoModify = false
    testingInfoModify = false;
    labLocationModify = false;
    /* currentProductId = 1;
    previewProductId = 1;
    editProductId = 1; */
    clearTestingInfo();
    return defaultState.errorClassName;
  }
  return [brandArray.isError, testInfoArray.isError, labSelectionArray.isError, reviewSelectionArray.isError];
}

function isMaterialFilled(formDetails) {
  if (formDetails.meta.form === 'addMaterial') {
    if (formDetails.meta.field.indexOf('typeOfMaterial') !== -1) {
      pcxData.typeOfMaterial = formDetails.payload;
    }
    if (pcxData.typeOfMaterial === '') {
      pcxData.isCompleted = false;
    }
    else {
      pcxData.isCompleted = true;
    }
  }
  return pcxData.isCompleted;
}

function clearMaterialFilled(action) {
  if (get(action, 'meta.form') === 'addMaterial') {
    pcxData = {
      typeOfMaterial: '',
      isCompleted: false
    };

  }
  return false;
}


export default function statusButton(state = defaultState, action) {
  switch (action.type) {
    case toggleAddMaterailModal.type:
      return { ...state, isAddMaterialModalOpen: action.payload };
    case displaySubmitButtonTrf.type:
      return { ...state, shouldDisplaySubmit: action.payload };
    case displayClearButtonTrf.type:
      return { ...state, shouldDisplayClear: action.payload };
    case updateMaterialField.type:
      return { ...state, updateMaterialField: action.payload };
    case onChangeProductType.type:
      // When product type changes (isChanged: true), clear test packages and material types from edit data
      if (action.payload && action.payload.isChanged === true) {
        return { 
          ...state, 
          onChangeProductType: action.payload,
          trfDataForEdit: {
            ...state.trfDataForEdit,
            // Clear test packages and material types to prevent re-binding after product type change
            testPackages: [],
            manualTest: [],
            materialType: [],
            testPackagesElectronic: [],
            testPackagesPackaging: [],
            testPackagesJewelry: []
          }
        };
      }
      return { ...state, onChangeProductType: action.payload };
    case onChangeScreeningInkVarient.type:
      return { ...state, onChangeScreeningInkVarient: action.payload };
    case currentProductTypeStore.type:
      return { ...state, currentProductTypeStore: getCurrentProductId(action.payload) };
    case InitialProductTypeStore.type:
      return { ...state, InitialProductTypeStore: getInitialProductId(action.payload) };
    case productTypeChangeStatus.type:
      return { ...state, productTypeChangeStatus: action.payload };
    case getProductIdEdit.type:
      return { ...state, getProductIdEdit: editFormProductId(action.payload) };
    case initialCertificationArry.type:
      return { ...state, initialCertificationArry: action.payload };
    case recycledContentValue.type:
      return { ...state, recycledContentValue: action.payload };
    case clearFormValueTRF.type:
      return {
        ...state,
        trfDataForEdit: {},
        errorClassName: clearValues(),
        isMaterialFilled: clearMaterialFilled(),
        preLoadComponents: false,
        isRetestEnable:'No'
      };
    case onChangeRetest.type:
      return { ...state, isRetestEnable: action.payload };

    case '@@redux-form/INITIALIZE':
      return { ...state, errorClassName: validate(action,state.isRetestEnable) };
    case '@@redux-form/CHANGE':
      return { ...state, errorClassName: isValidated(action,state.isRetestEnable,state.productTypeChangeStatus), isMaterialFilled: isMaterialFilled(action), updateEnable: defaultState.updateEnable };
    case '@@redux-form/RESET':
      return { ...state, errorClassName: clearValues(action), isMaterialFilled: clearMaterialFilled(action) };
    case createServiceAction('trfData', 'success').type:
      return { ...state, result: action.data,isRetestEnable:'No' };
    case createServiceAction('trfDetails', 'success').type:
      return { ...state, trfData: action.data };
    case createServiceAction('addMaterial', 'success').type:
      return { ...state, materialData: action.data };
    case createServiceAction('trfUpdate', 'requested').type:
      return { ...state, isLoading: true };
    case createServiceAction('locationSearch', 'error').type:
      return { ...state, isLoading: false };
    case createServiceAction('trfUpdate', 'success').type:
      return { ...state, trfDataForEdit: action.data, isLoading: false, preLoadComponents: true, updateEnable: false };
    case createServiceAction('trfUpdate', 'after_success').type:
      return { ...state, isLoading: false, preLoadComponents: false, updateEnable: false };
    case createServiceAction('labLocations', 'loading').type:
      return { ...state, labLocationsLoading: true };
    case createServiceAction('labLocations', 'success').type:
      return {
        ...state,
        labLocationCountries: get(action.data, 'data.countries', []),
        labLocationsLoading: false
      };
    case createServiceAction('labLocations', 'error').type:
      return { ...state, labLocationsLoading: false };
    default:
      return state;
  }
}